<template>
    <input type="text"
        id="search"
        name="autocomplete"
        :class="{'is-invalid': $v.form.searchValue.$error, 'is-valid': $v.form.searchValue.$dirty && !$v.form.searchValue.$invalid}"
        v-on:input="$v.form.searchValue.$touch"
        v-model="form.searchValue"
        placeholder="Enter your address">
</template>

<script>
import { required } from 'vuelidate/lib/validators';
export default {
    prop:['value'],
    mounted() {
       this.initGooglePlaces()
    },
    data(){
        return {
            place: '',
            autocomplete: '',
            search: {
                address: '',
                city: '',
                state: '',
                postcode: '',
                country: ''
            },
            form:{
                searchValue: ''
            },
        }
    },
    validations(){
        return {
                form:{
                    searchValue: {
                        required
                    }
                } 
            }
    },
    methods:{
        initGooglePlaces() {
            // Create the autocomplete object, restricting the search to geographical
            // location types.
            this.autocomplete = new google.maps.places.Autocomplete(
                (document.getElementById('search')),
                {types: ['geocode']});

            // When the user selects an address from the dropdown, populate the address
            // fields in WHMCS.
            this.autocomplete.addListener('place_changed', this.placeChanged);
            // prevent triggering submit
            document.getElementById('search').addEventListener("keypress", function(e){
                var keyCode = e.which; 
                if(keyCode === 13){
                    e.preventDefault();
                }
            })
            
        },
        // geolocate() {
        //     // narrow down search results to approxmate location
        //     if (navigator.geolocation) {
        //         navigator.geolocation.getCurrentPosition(function(position) {
        //             var geolocation = {
        //             lat: position.coords.latitude,
        //             lng: position.coords.longitude
        //             };
        //             var circle = new google.maps.Circle({
        //             center: geolocation,
        //             radius: position.coords.accuracy
        //             });
        //             this.autocomplete.setBounds(circle.getBounds());
        //         }.bind(this));
        //     }
        // },
        placeChanged(){
            this.place = this.autocomplete.getPlace()
            this.addressSelected = true
            if(!this.place['address_components']) return;

            this.search.address = this.place.name
            this.search.state = this.getGoogleAddressComponent('administrative_area_level_1') || this.place.adr_address.match(/class="region">([^\<]*)/)[1]
            this.search.city = this.getGoogleAddressComponent('locality') || this.place.adr_address.match(/class="locality">([^\<]*)/)[1]
            this.search.postcode = this.getGoogleAddressComponent('postal_code')
            this.search.country = this.getGoogleAddressComponent('country', true)
            document.getElementById('search').value = this.buildAddress()
            this.$emit('change', this.search)
        },
        buildAddress(){
            return this.search.address+', '+this.search.city+' '+this.search.state+' '+this.search.postcode+', '+this.search.country
        },
        getGoogleAddressComponent(type, shortname){
            var component = this.place.address_components.find(function(el){
                return el.types.indexOf(type) > -1
            })
            return component ? component[shortname ? 'short_name' : 'long_name'] : undefined
        }
    }
}
</script>

<style>
</style>
